module.exports = __webpack_public_path__ + "static/media/passportToken.9281ac49.svg";